/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CylinderBufferGeometry, PlaneBufferGeometry, BoxBufferGeometry, TorusBufferGeometry, BufferGeometry, Float32BufferAttribute } from 'three';
export const toVec3 = (v) => {
    return v.toArray();
};
export class Geometry {
    static arrowLine() {
        return new CylinderBufferGeometry(0.0075, 0.0075, 1, 3, 1);
    }
    static rotateAngleLine() {
        return new CylinderBufferGeometry(0.0175, 0.0175, 1, 3, 1);
    }
    static axisPlane() {
        return new PlaneBufferGeometry(10000, 10000, 2, 2);
    }
    static translateTool() {
        return new CylinderBufferGeometry(0, 0.08, 0.2, 12, 1);
    }
    static scaleTool() {
        return new BoxBufferGeometry(.2, .075, .2);
    }
    // static rotateSphere() {
    //   const a = Math.PI / 4;
    //   const b = a * 1.5;
    //   const geo = new SphereBufferGeometry(0.3, 6, 6, b, a, b, a);
    //   geo.rotateX(-Math.PI / 2);
    //   return geo;
    // }
    static rotateTool() {
        const a = Math.PI * 0.23; // 33333;
        const geo = new TorusBufferGeometry(0.8, .05, 8, 8, a);
        geo.rotateZ(Math.PI * 0.5 - a * 0.5);
        return geo;
    }
    static axisRotateArc() {
        // const geo = new TorusBufferGeometry(.5, .0075, 8, 40, Math.PI * 2);
        // geo.rotateX(Math.PI * 0.5);
        // geo.rotateY(Math.PI * 0.5);
        // return geo;
        return new TorusBufferGeometry(.8, .0075, 8, 40, Math.PI * 2);
    }
    static createLine(from, to) {
        const line = new BufferGeometry();
        line.addAttribute('position', new Float32BufferAttribute([...from.toArray(), ...to.toArray()], 3));
        return line;
    }
}
//# sourceMappingURL=Geometry.js.map